;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('get', GetFilter)

  GetFilter.$inject = []

  function GetFilter () {
    return function (val, key) {
      return _.get(val, key)
    }
  }
})(window.angular, window._)
